import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { FC, ReactNode } from 'react';

interface SearchableTableLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const SearchableTableLayout: FC<SearchableTableLayoutProps> & {
  FiltersWrapper: FC<React.HTMLAttributes<HTMLDivElement>>;
  TableWrapper: FC<{ children: ReactNode }>;
} = (props) => {
  const { children, ...restProps } = props;
  return (
    <Container
      maxWidth="xl"
      sx={{
        p: {
          xs: 2,
          md: 3,
        },
      }}
      {...restProps}
    >
      <Stack direction={{ xs: 'column', lg: 'row' }} spacing={4}>
        {children}
      </Stack>
    </Container>
  );
};

const FiltersWrapper: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => (
  <Stack sx={{ width: '100%', maxWidth: { lg: '320px' } }} spacing={4} {...props} />
);

const TableWrapper: FC<{ children: ReactNode }> = ({ children }) => (
  <Box flex={1}>
    <Card variant="outlined">{children}</Card>
  </Box>
);

SearchableTableLayout.FiltersWrapper = FiltersWrapper;
SearchableTableLayout.TableWrapper = TableWrapper;

export { SearchableTableLayout };
